import React, {Fragment, useMemo} from 'react';
import { Popover, Transition } from '@headlessui/react';
import useBrandIcon from "../../../../hooks/useBrandIcon";
import {formatTime} from "../../../../helpers/time";
import Slider from "../../../atoms/slider/Slider";
import useWindowSize from "../../../../hooks/useWindowSize";
import {MdFastForward, MdFastRewind} from "react-icons/md";
import {GlobalContext} from "../../../../context/GlobalContext";
import CustomPopover from "../../../atoms/CustomPopover";
import {useI18n} from "../../../../i18n";

interface Props {
    handlePlayPause: () => void;
    handleFastForward?: () => void;
    handleFastRewind?: () => void;
    handleLoopSection?: (section: string) => void;
    handleStop: () => void;
    currentTime?: number;
    isPlaying: boolean;
    ended: boolean;
    play?: boolean;
    repeat?: boolean;
    mic?: boolean;
    volume?: number;
    setVolume?: (val: number) => void;
    small?: boolean;
    showTime?: boolean;
    showVolume?: boolean;
}

const AudioController = ({
                             handlePlayPause,
                             handleFastForward,
                             handleFastRewind,
                             handleLoopSection,
                             isPlaying,
                             volume,
                             setVolume,
                             currentTime,
                             repeat,
                             mic,
                             small,
                             showTime,
                             showVolume = true
                         }: Props) => {
    const {t} = useI18n();
    const play_icon = useBrandIcon().play
    const pause_icon = useBrandIcon().pause
    const repeat_icon = useBrandIcon().repeat
    const disabled_mic_icon = useBrandIcon().disabled_mic
    const speaker = useBrandIcon().speaker;

    const {currentSong} = React.useContext<any>(GlobalContext);

    const sections = useMemo(() => {
        try {
            if (!currentSong?.lyrics) return [];
            return typeof currentSong.lyrics === 'string'
                ? JSON.parse(currentSong.lyrics)
                : currentSong.lyrics;
        } catch (e) {
            console.error('Failed to parse lyrics:', e);
            return [];
        }
    }, [currentSong]);

    const {isMobile} = useWindowSize();


    return (
        isMobile ? <div className={'flex justify-center items-center gap-2'}>
                {<img src={repeat_icon} alt={t('components.audioController.repeatAlt')} className="w-[50px] xl:w-[40px] cursor-pointer"/>}
                {handleFastRewind && <MdFastRewind size={50} color={'white'} onClick={() => handleFastRewind()}/>}
                {isPlaying ? <img onClick={() => {
                        handlePlayPause()
                    }} src={pause_icon} alt={t('components.audioController.pauseAlt')}
                                  className={`w-[75px] ${small ? 'xl:w-[25px]' : 'xl:w-[40px]'} cursor-pointer`}/> :
                    <img onClick={() => {
                        handlePlayPause()
                    }} src={play_icon} alt={t('components.audioController.playAlt')}
                         className={`w-[75px] ${small ? 'xl:w-[25px]' : 'xl:w-[40px]'} cursor-pointer`}/>}
                {handleFastForward && <MdFastForward size={50} color={'white'} onClick={() => handleFastForward()}/>}
                <img src={disabled_mic_icon} alt={t('components.audioController.micAlt')} className="w-[50px] xl:w-[40px] cursor-pointer"/>
            </div>

            :

            <div className={'flex items-center gap-1'}>
                {/* TODO:  Use Proper Button Later  */}
                {showTime &&
                    <div className={`min-w-[30px] ${small ? 'xl:min-w-[35px]' : 'xl:min-w-[42px]'} ml-1 xl:ml-4`}>
                        {currentTime ?
                            <h3 className={`text-white text-xs ${small ? 'xl:text-xs' : 'xl:text-sm'}`}>{formatTime(currentTime)}</h3> :
                            <h3 className={'text-white text-xs xl:text-sm'}>{t('components.audioController.initialTime')}</h3>}
                    </div>}
                {isPlaying ? <div className={'flex'}>

                        <button>
                            <img onClick={() => {
                                handlePlayPause()
                            }} src={pause_icon} alt={t('components.audioController.pauseAlt')}
                                 className="w-[20px] xl:w-[40px] mr-2 cursor-pointer"/>
                        </button>
                    </div> :
                    <div className={'flex'}>
                        <button>
                            <img onClick={() => {
                                handlePlayPause()
                            }} src={play_icon} alt={t('components.audioController.playAlt')}
                                 className="w-[20px] xl:w-[40px] mr-2 cursor-pointer"/>
                        </button>
                    </div>
                }
                {handleLoopSection && (
                    <CustomPopover
                        icon={repeat_icon}
                        items={sections}
                        onSelect={(item: any) => handleLoopSection(item.section)}
                        getLabel={(item: any) => item.section}
                    />
                )}
                {mic && <img src={disabled_mic_icon} alt={t('components.audioController.micAlt')} className="w-[20px] xl:w-[40px] mr-2 cursor-pointer"/>}

                {/*Volume Slider */}
                {/*TODO: Refine the range styling to fit more with the brand */}

                {showVolume && <div className={'hidden sm:flex items-center  !min-w-[42px] ml-2'}>
                    <img src={speaker} alt={t('components.audioController.speakerAlt')} className="w-[12px] mr-2 cursor-pointer"/>

                    <Slider onChange={setVolume} small={small}/>
                </div>}

            </div>
    );
};

export default AudioController;
